import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";

import appStyles from "../../../../appStyles";

export default function RulesIcon(props) {
  const w = props.width || 40;
  const h = props.height || 40;

  return (
    <TouchableOpacity style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width={w}
        height={h}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M23.5057 18.8524C23.2411 19.1179 22.8112 19.1183 22.5461 18.8532L21.1363 17.4435C20.8768 17.1839 20.8768 16.763 21.1363 16.5035C21.3959 16.2439 21.8168 16.2439 22.0763 16.5035L23.0197 17.4468L25.3759 15.0905C25.6357 14.8307 26.057 14.8307 26.3168 15.0905C26.5762 15.35 26.5766 15.7706 26.3176 16.0305L23.5057 18.8524ZM19.333 17.3335C19.333 16.9653 19.0345 16.6668 18.6663 16.6668H13.9997C13.6315 16.6668 13.333 16.9653 13.333 17.3335C13.333 17.7016 13.6315 18.0001 13.9997 18.0001H18.6663C19.0345 18.0001 19.333 17.7016 19.333 17.3335ZM25.5297 21.4101C25.7892 21.1505 25.7892 20.7297 25.5297 20.4701C25.2701 20.2105 24.8492 20.2105 24.5897 20.4701L23.333 21.7268L22.0763 20.4701C21.8168 20.2105 21.3959 20.2105 21.1363 20.4701C20.8768 20.7297 20.8768 21.1505 21.1363 21.4101L22.393 22.6668L21.1363 23.9235C20.8768 24.183 20.8768 24.6039 21.1363 24.8635C21.3959 25.123 21.8168 25.123 22.0763 24.8635L23.333 23.6068L24.5897 24.8635C24.8492 25.123 25.2701 25.123 25.5297 24.8635C25.7892 24.6039 25.7892 24.183 25.5297 23.9235L24.273 22.6668L25.5297 21.4101ZM19.333 22.6668C19.333 22.2986 19.0345 22.0001 18.6663 22.0001H13.9997C13.6315 22.0001 13.333 22.2986 13.333 22.6668C13.333 23.035 13.6315 23.3335 13.9997 23.3335H18.6663C19.0345 23.3335 19.333 23.035 19.333 22.6668Z"
          fill="white"
        />
      </Svg>
    </TouchableOpacity>
  );
}
